import React, { useEffect, useState } from 'react';
import { Select, Typography } from 'antd';
import { apiClient } from '../../services/apiClient';

interface DevRosterUser {
  id: string;
  username: string;
  email: string;
  company_count?: number;
}

interface DevRosterLoginPickerProps {
  onSelect: (identifier: string) => void;
}

/** Dev-only quick pick for roster-seeded Postgres users (usernames only — no PII in UI copy). */
export const DevRosterLoginPicker: React.FC<DevRosterLoginPickerProps> = ({ onSelect }) => {
  const [users, setUsers] = useState<DevRosterUser[]>([]);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      return;
    }
    void (async () => {
      try {
        const response = await apiClient.get<DevRosterUser[]>('/dev/users', {
          params: { is_active: true, limit: 100 },
        });
        const data: DevRosterUser[] = response.data ?? [];
        const rows = data
          .filter((row) => row.username && (row.company_count ?? 0) > 0)
          .sort((a, b) => a.username.localeCompare(b.username));
        setUsers(rows);
      } catch {
        setUsers([]);
      }
    })();
  }, []);

  if (process.env.NODE_ENV !== 'development' || users.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
        Dev roster user (password: demopass)
      </Typography.Text>
      <Select
        showSearch
        allowClear
        placeholder="Pick a seeded user…"
        optionFilterProp="label"
        filterOption={(input, option) => {
          const q = input.trim().toLowerCase();
          if (!q) return true;
          const label = String(option?.label ?? '').toLowerCase();
          const value = String(option?.value ?? '').toLowerCase();
          return label.includes(q) || value.includes(q);
        }}
        style={{ width: '100%' }}
        onChange={(value) => {
          if (typeof value === 'string' && value) {
            onSelect(value);
          }
        }}
        options={users.map((row) => ({
          value: row.email || row.username,
          label: `${row.username} · ${row.email || 'no-email'} (${row.company_count ?? 0} companies)`,
        }))}
      />
    </div>
  );
};
